import React from 'react'
import { FormGroup, Label } from 'reactstrap'
import { formatDate } from '@/utils/dateUtilities'
import Resx from '@/components/Resx'
import { InfoContent } from '@/components/InfoRow'
import { FileAttachments } from '@/components/fileAttachments'
import context from '@/context'

const MessageDetailContent = function MessageDetailContent ({ message, attachments }) {
  return (
    <React.Fragment>
      <FormGroup>
        <Label><Resx name='Messages.Recipient' /></Label>
        <InfoContent>{message.recipientName}</InfoContent>
      </FormGroup>
      <FormGroup>
        <Label><Resx name='Messages.Subject' /></Label>
        <InfoContent>{message.subject}</InfoContent>
      </FormGroup>
      <FormGroup>
        <Label><Resx name='Messages.DueDate' /></Label>
        <InfoContent>{formatDate(message.dueDate)}</InfoContent>
      </FormGroup>
      <FormGroup>
        <Label><Resx name='Messages.MessageDetail' /></Label>
        <InfoContent><span dangerouslySetInnerHTML={{ __html: message.text }} /></InfoContent>
      </FormGroup>
      <FormGroup>
        <Label><Resx name='Common.Attachments' /></Label>
        <InfoContent>
          <FileAttachments attachments={attachments || []} readonly downloadAction={context.api.messagesService.download} />
        </InfoContent>
      </FormGroup>
    </React.Fragment>
  )
}

export { MessageDetailContent }



// WEBPACK FOOTER //
// ./src/components/messages/detail-content.js